import { useState, type JSX } from "react";
import type { WorkflowTabId } from "@/types/models";
import { TabStrip, workflowPanelId, workflowTabId } from "./TabStrip";
import { QuickActions } from "./QuickActions";
import { Deals } from "./Deals";
import { Tasks } from "./Tasks";
import { Profile } from "./Profile";
import "./Workflow.scss";

export function Workflow(): JSX.Element {
  const [tab, setTab] = useState<WorkflowTabId>("quick-actions");

  const content =
    tab === "quick-actions" ? (
      <QuickActions />
    ) : tab === "deals" ? (
      <Deals />
    ) : tab === "tasks" ? (
      <Tasks />
    ) : (
      <Profile />
    );

  return (
    <div className="workflow">
      <div className="workflow__shell">
        <div className="workflow__tabs">
          <TabStrip active={tab} onChange={setTab} />
        </div>

        <div className="workflow__content">
          <div
            className="workflow__panel"
            id={workflowPanelId(tab)}
            role="tabpanel"
            aria-labelledby={workflowTabId(tab)}
            tabIndex={0}
          >
            {content}
          </div>
        </div>
      </div>
    </div>
  );
}
